import { styled } from '@mui/material'

export const MenuItemsWrapper = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  minWidth: 200,
  color: 'black'
}))
